
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/cart/checkout",
      function () {
        return require("private-next-pages/shop/cart/checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/cart/checkout"])
      });
    }
  